import React from 'react';
import { useEditor } from '../context/EditorProvider.jsx';
import './TabsBar.css';

export default function TabsBar() {
  const { state, dispatch } = useEditor();
  return (
    <div className="tabs-bar">
      {state.files.map((file) => (
        <div
          key={file.id}
          className={
            'tab' + (file.id === state.activeFileId ? ' active' : '')
          }
          onClick={() => dispatch({ type: 'SET_ACTIVE', id: file.id })}
        >
          {file.filename}
        </div>
      ))}
    </div>
  );
} 